import React, { useEffect, useState } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const RemoveSessionByManager = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();

  const [sessions, setSessions] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [reason, setReason] = useState("");

  /* ================= FETCH SESSIONS ================= */
  useEffect(() => {

    const fetchAttendance = async () => {
      try {
        const res = await axiosSalary.get(
          `/DailyAttendance/GetAttendanceForManagerEdit`,
          {
            params: {
              groupId: user?.groupId,
              restId: rowData.restId,
              empId: rowData?.empId,
              attendanceDate: new Date(
                rowData.attendanceDate.split("/").reverse().join("-")
              ).toISOString(),
            },
          }
        );

        const data = res.data;
        const allSessions = data?.sessions || [];

        setSessions(allSessions);

        // ✅ auto select last session
        if (allSessions.length > 0) {
          setSelectedSessionId(allSessions[allSessions.length - 1].sessionId);
        }

      } catch (err) {
        console.error("Fetch sessions error:", err);
      }
    };

    if (open && rowData) {
      fetchAttendance();
    }

  }, [open, rowData, user]);

  /* ================= SUBMIT ================= */
  const handleRemove = async () => {

    if (!selectedSessionId) {
      alert("Please select a session");
      return;
    }

    try {

      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,

        attendanceDate: new Date(
          rowData.attendanceDate.split("/").reverse().join("-")
        ).toISOString(),

        sessionId: selectedSessionId,
        userId: user?.userId,
        reason: reason
      };

      await axiosSalary.post(
        "/DailyAttendance/RemoveSessionByManager",
        payload
      );

      alert("Session removed successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error("Remove session error:", err);
      alert("Failed to remove session");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[320px]">

        <h3 className="font-semibold mb-3">
          Remove Session - {rowData?.empName}
        </h3>

        <div className="space-y-2 text-sm">

          {/* SESSION LIST */}
          <select
            value={selectedSessionId}
            onChange={(e) => setSelectedSessionId(e.target.value)}
            className="w-full border p-2 rounded"
          >
            <option value="">Select Session</option>

            {sessions.map((s) => (
              <option key={s.sessionId} value={s.sessionId}>
                {s.inTimeIst} → {s.outTimeIst || "OPEN"}
              </option>
            ))}
          </select>

          {/* REASON */}
          <textarea
            placeholder="Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full border p-2 rounded"
          />

        </div>

        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleRemove}
            className="px-3 py-1 bg-red-600 text-white rounded"
          >
            Remove
          </button>

        </div>

      </div>

    </div>
  );
};

export default RemoveSessionByManager;